import { Pipe, PipeTransform } from '@angular/core';
import { AppdataService } from '../service/appdata.service';

@Pipe({
  name: 'getTagNameById',
  standalone: false
})
export class GetTagNameByIdPipe implements PipeTransform {

  constructor(
    private appData: AppdataService
  ) { }
  async transform(id: string): Promise<string> {
    let tag = await this.appData.tags.find(tag => tag.id === id);
    let tagCat = await this.appData.tagGroups.find(tagCat => tagCat.id === tag?.tagGroupId);
    return tag ? `${tagCat?.name} | ${tag.name}` : id;
  }

}
